import React, { useState } from "react";
import { List, Button } from "antd";

const Step1 = ({ nextStep }) => {
  const [choice, setChoice] = useState("");

  const handleItemClick = (value) => {
    setChoice(value);
  };

  const data = [
    { label: "Me", value: "option1" },
    { label: "Friend or family member", value: "option2" },
    { label: "My Client", value: "option3" },
  ];

  return (
    <div className="register-steps-container">
      <h3>Step 1: Choose one</h3>
      <div className="list-container">
        <List
          itemLayout="horizontal"
          dataSource={data}
          renderItem={(item) => (
            <div
              className={`list-item ${choice === item.value ? "selected" : ""}`}
              onClick={() => handleItemClick(item.value)}
            >
              <List.Item>
                <List.Item.Meta title={item.label} />
              </List.Item>
            </div>
          )}
        />
      </div>
      <Button
        type="primary"
        onClick={() => nextStep({ choice })}
        style={{ marginTop: "20px" }}
      >
        Next
      </Button>
    </div>
  );
};

export default Step1;
